import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { Meteor } from 'meteor/meteor';
import { isEmpty } from 'lodash';
import { withTracker } from 'meteor/react-meteor-data';
import {
  Box,
  Button,
  ButtonGroup,
  FormControl,
  IconButton,
  InputLabel,
  Pagination,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Select,
  Stack
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import uuid from 'uuid/v1';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StorageIcon from '@mui/icons-material/Storage';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';

const MapsAdvancedILSField = props => {
  const {
    listComponentsAdvanced,
    ipsOfIsl,
    setListComponentsAdvanced,
    setIpsOfIsl,
    serverConnection
  } = props;
  const [linksState, setLinksState] = React.useState(ipsOfIsl.links);
  const [viewState, setViewState] = React.useState(ipsOfIsl.viewDefault);
  const itemsPerPage = 5;
  const [serverSelected, setServerSelected] = React.useState({});
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.ISLComponent.name
  );
  const [page, setPage] = React.useState(1);
  const [inputForm, setInputForm] = React.useState('server');
  const [type, setType] = React.useState('');
  const [value, setValue] = React.useState('');
  const allTypes = ['ISL', 'Airflow'];
  const allViews = ['Imagenes', 'Listado'];

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const [openModal, setOpenModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.ISLComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(listComponentsAdvanced.ISLComponent.iconSvg);
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.ISLComponent.libraryIcon
  );

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        ISLComponent: {
          name: listComponentsAdvanced.ISLComponent.name,
          show: listComponentsAdvanced.ISLComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        ISLComponent: {
          name: listComponentsAdvanced.ISLComponent.name,
          show: listComponentsAdvanced.ISLComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  const isValidURL = urlString => {
    const patronURL = new RegExp(
      '^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$',
      'i'
    );
    return !!patronURL.test(urlString);
  };

  const handleAddLink = () => {
    const isValid = isValidURL(value);
    if (isValid === true) {
      if (linksState.length === 0) {
        setLinksState([{ url: value, type }]);
        setIpsOfIsl({ links: [{ url: value, type }], viewDefault: viewState });
      } else {
        setLinksState(prevLinks => [...prevLinks, { url: value, type }]);
        setIpsOfIsl(prevIpsOfIsl => ({
          links: [...prevIpsOfIsl.links, { url: value, type }],
          viewDefault: viewState
        }));
      }
    } else {
      Bert.alert('URL NOT VALID', 'danger');
    }
  };

  const handleDeleteLink = index => {
    setLinksState(prevLinks => prevLinks.filter((_, i) => i !== index));
    setIpsOfIsl(prevIpsOfIsl => ({
      ...prevIpsOfIsl,
      links: prevIpsOfIsl.links.filter((_, i) => i !== index)
    }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box display="column" width="50%">
      <>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <StorageIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() => {
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                ISLComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.ISLComponent.show
                }
              });
            }}
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={listComponentsAdvanced.ISLComponent.iconFontawesome}
            startLibrary={listComponentsAdvanced.ISLComponent.libraryIcon}
            svg={listComponentsAdvanced.ISLComponent.iconSvg}
            startCategorySvg={listComponentsAdvanced.ISLComponent.cetegorySvg}
          />
        </Box>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <FormControl sx={{ width: '50%' }}>
            <InputLabel id="demo-select-label">Visualización</InputLabel>
            <Select
              labelId="demo-select-label"
              id="demo-select"
              label="Visualización"
              size="small"
              value={viewState}
              onChange={event => {
                setViewState(event.target.value);
                setIpsOfIsl(prevIpsOfIsl => ({ ...prevIpsOfIsl, viewDefault: event.target.value }));
              }}
            >
              {allViews.map(item => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: 'flex',
            '& > *': {
              m: 1
            }
          }}
        >
          <ButtonGroup variant="contained" aria-label="outlined primary button group">
            <Button
              style={{
                fontSize: 11,
                backgroundColor: inputForm === 'server' ? '#2A3F90' : 'inherit',
                color: inputForm === 'server' ? 'white' : 'inherit',
                size: 'small',
                border: '1px solid #2A3F90'
              }}
              onClick={() => {
                setInputForm('server');
              }}
              disabled={inputForm === 'server'}
            >
              Server
            </Button>
            <Button
              style={{
                fontSize: 11,
                backgroundColor: inputForm === 'input' ? '#2A3F90' : 'inherit',
                color: inputForm === 'input' ? 'white' : 'inherit',
                size: 'small',
                border: '1px solid #2A3F90'
              }}
              onClick={() => {
                setInputForm('input');
              }}
              disabled={inputForm === 'input'}
            >
              Input url
            </Button>
          </ButtonGroup>
        </Box>

        <Box
          component="form"
          sx={{
            display: 'flex',
            m: 1,
            width: '100%',
            alignItems: 'center'
          }}
          noValidate
          autoComplete="off"
        >
          {inputForm === 'input' && (
            <TextField
              id="outlined-required"
              label="Introduce una URL"
              size="small"
              value={value}
              onChange={event => setValue(event.target.value)}
              sx={{ width: '50%', mr: 1 }}
            />
          )}
          {inputForm === 'server' && (
            <FormControl sx={{ width: '50%', mr: 1 }}>
              <InputLabel id="demo-select-label">Conexión IPS</InputLabel>
              <Select
                labelId="demo-select-label"
                id="demo-select"
                label="Conexión IPS"
                size="small"
                value={serverSelected ? serverSelected.name : ''}
                onChange={event => {
                  const serverSelectedSearch = serverConnection.find(
                    element => element.name === event.target.value
                  );
                  setServerSelected(serverSelectedSearch);
                  setValue(serverSelectedSearch.domain);
                }}
              >
                {serverConnection.map(item => (
                  <MenuItem key={item.name} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <FormControl sx={{ width: '25%', mr: 1 }}>
            <InputLabel id="demo-select-label">Tipo</InputLabel>
            <Select
              labelId="demo-select-label"
              id="demo-select"
              label="Tipo"
              size="small"
              value={type}
              onChange={event => setType(event.target.value)}
            >
              {allTypes.map(item => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="success"
            onClick={handleAddLink}
            sx={{ width: '25%' }} // Ajusta el ancho del botón
          >
            Añadir
          </Button>
        </Box>

        <Table>
          <TableBody>
            {linksState.slice(startIndex, endIndex).map((item, index) => (
              <TableRow key={uuid()}>
                <TableCell>{item.url}</TableCell>
                <TableCell>{item.type}</TableCell>
                <TableCell>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteLink(startIndex + index)}
                    sx={{
                      color: '#2A3F90'
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            marginTop: '20px',
            justifyContent: 'center'
          }}
        >
          <Pagination
            count={Math.ceil(linksState.length / itemsPerPage)}
            page={page}
            onChange={handleChangePage}
            sx={{
              '& .MuiPaginationItem-page.Mui-selected': {
                backgroundColor: '#2A3F90',
                color: 'white'
              },
              '& .MuiPaginationItem-page.Mui-selected .MuiPaginationItem-pageNumber': {
                color: 'white'
              }
            }}
          />
        </Stack>
      </>
    </Box>
  );
};

export default withTracker(() => {
  const connectionsSub = Meteor.isClient && Meteor.subscribe('telemetryConnections');
  return {
    loading: !connectionsSub.ready(),
    serverConnection: TelemetryConnections.find({ serverType: { $in: ['IGPS'] } }).fetch()
  };
})(MapsAdvancedILSField);
MapsAdvancedILSField.defaultProps = {
  ipsOfIsl: {},
  setIpsOfIsl: () => {},
  serverConnection: []
};
MapsAdvancedILSField.propTypes = {
  ipsOfIsl: PropTypes.object,
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func.isRequired,
  serverConnection: PropTypes.array,
  setIpsOfIsl: PropTypes.func
};
